import Link from 'next/link';
import { ArrowRightIcon } from '@phosphor-icons/react';

const EQ_BARS = [
  { height: '40%', delay: '0s' },
  { height: '80%', delay: '.15s' },
  { height: '55%', delay: '.3s' },
  { height: '100%', delay: '.05s' },
  { height: '65%', delay: '.25s' },
  { height: '35%', delay: '.4s' },
  { height: '75%', delay: '.1s' }
];

interface LiveDemoCardProps {
  liveEventsUrl: string;
}

export default function LiveDemoCard({ liveEventsUrl }: LiveDemoCardProps) {
  return (
    <div className='px-6 mt-auto'>
      <div className='border border-divider rounded-lg overflow-hidden'>
        <div className='h-14 flex items-end justify-center gap-1 bg-gradient-to-r from-[#ED2E8E] via-[#8b2ae8] to-[#2F6BFF] py-3'>
          {EQ_BARS.map((bar, i) => (
            <span
              key={i}
              className='w-1 rounded-full bg-white/90'
              style={{ height: bar.height, animation: 'eqBounce 1.1s ease-in-out infinite', animationDelay: bar.delay }}
            />
          ))}
        </div>
        <div className='bg-content3 p-3'>
          <h4 className='text-[15px] font-bold leading-5 mb-1'>See StreamAlive live</h4>
          <p className='text-xs leading-[1.45] text-default-700 mb-2'>Get a quick live demo — watch it in action or ask anything. Free sessions several times a week.</p>
          <Link
            href={liveEventsUrl || '#'}
            target='_blank'
            className='flex items-center justify-center gap-2 w-full bg-black text-white text-[13px] font-semibold rounded-[9px] py-2 hover:opacity-90'
          >
            See what's live
            <ArrowRightIcon size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
